import React from 'react'
import { useFeatureFlags, FeatureFlags } from '../hooks'

function withFeatureFlags(Component) {
  const baseName = Component.displayName || Component.name || 'Component'

  function WithFeatureFlags(props) {
    const featureFlags = useFeatureFlags()
    return <Component {...props} featureFlags={featureFlags} />
  }

  WithFeatureFlags.displayName = `withFeatureFlags(${baseName})`
  return WithFeatureFlags
}

export { FeatureFlags }

export default withFeatureFlags
